export default __webpack_public_path__ + "static/media/OptionsIcon.9bbdc31d.svg";